import React, {ReactNode} from "react";
import { Box } from "@mui/material";

// Define the prop types for TabPanel
interface TabPanelProps {
    children?: ReactNode;  // Allow children of any React type
    value: number;         // The current tab value
    index: number;         // The index of this tab
}

// TabPanels component with children prop added
const TabPanels: React.FC<TabPanelProps> = ({ children, value, index }) => {
    return (
        <div role="tabpanel" hidden={value !== index}>
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
};

export default TabPanels;
